// eslint-disable-next-line
export const LOGIN_MODAL_OPEN = 'LOGIN_MODAL_OPEN';
export const SET_LOGIN_MODAL_STORE_DATA = 'SET_LOGIN_MODAL_STORE_DATA';
